import { PROOF_ENFORCEMENT_MODES } from "../../../../../constants/proofEnforcementModes";
import {
  PROOF_APPROVAL_MODES,
  normalizeProofApprovalMode,
} from "../../../../../constants/proofApprovalModes";

export const isProofReadinessBlockingGeneration = ({ mode, status }) =>
  ["idle", "loading", "error"].includes(status) ||
  (mode !== PROOF_ENFORCEMENT_MODES.NONE && status === "blocked");

export const normalizeProofReadinessStatus = ({ mode, validation }) => {
  if (validation?.evaluationScope === "purchase_order") {
    const status = String(validation?.status || "").trim();
    if (["ready", "partial", "blocked", "complete", "not_required"].includes(status)) {
      return status;
    }
  }
  if (mode === PROOF_ENFORCEMENT_MODES.NONE) return "ready";
  if (validation?.status === "not_required") return "not_required";
  return validation?.valid ? "ready" : "blocked";
};

export const getProofReadinessCardCopy = ({ status, validation, error }) => {
  const approvalMode = normalizeProofApprovalMode(validation?.approvalMode);
  const summary = validation?.summary || {};
  const perPurchaseOrder = validation?.evaluationScope === "purchase_order";

  if (perPurchaseOrder && status === "partial") {
    const ready = Number(summary.readyToCreatePurchaseOrderCount ?? summary.readyPurchaseOrderCount) || 0;
    const proofBlocked = Number(summary.proofBlockedPurchaseOrderCount) || 0;
    const shippingBlocked = Number(summary.shippingBlockedPurchaseOrderCount) || 0;
    return {
      actionLabel: "Partially Ready",
      message: `${ready} PO${ready === 1 ? "" : "s"} ready · ${proofBlocked} with outstanding proof requirements · ${shippingBlocked} with shipping issues (some POs may have both).`,
    };
  }
  if (perPurchaseOrder && status === "complete") {
    return {
      actionLabel: "Complete",
      message: "All Purchase Order candidates have been generated.",
    };
  }
  if (perPurchaseOrder && status === "ready") {
    const ready = Number(summary.readyToCreatePurchaseOrderCount ?? summary.readyPurchaseOrderCount) || 0;
    return {
      actionLabel: "Ready",
      message: ready > 0
        ? `${ready} Purchase Order${ready === 1 ? "" : "s"} ready to generate.`
        : "Purchase Order candidates are ready.",
    };
  }
  if (perPurchaseOrder && status === "blocked") {
    const proofBlocked = Number(summary.proofBlockedPurchaseOrderCount) || 0;
    const shippingBlocked = Number(summary.shippingBlockedPurchaseOrderCount) || 0;
    return {
      actionLabel: "Needs Attention",
      message: `${proofBlocked} PO(s) with outstanding proof requirements · ${shippingBlocked} with shipping issues (some POs may have both).`,
    };
  }
  if (status === "not_required") {
    return {
      actionLabel: "Not Required",
      message: "No proofs are required for this order.",
    };
  }
  if (status === "ready") {
    return {
      actionLabel: "Ready",
      message: approvalMode === PROOF_APPROVAL_MODES.COMPLETE_PACKAGE
        ? "Complete package approved."
        : "Required proofs are approved.",
    };
  }
  if (status === "error") {
    return {
      actionLabel: "Check Failed",
      message: error,
    };
  }
  if (status === "blocked") {
    return {
      actionLabel: "Needs Attention",
      message: approvalMode === PROOF_APPROVAL_MODES.COMPLETE_PACKAGE
        ? "The complete proof package is missing or awaiting approval."
        : "One or more required proofs are missing or awaiting approval.",
    };
  }
  return {
    actionLabel: "Checking",
    message: "Checking proof requirements.",
  };
};

